import { render } from "./MovieSearch.vue?vue&type=template&id=32f2e3ae&scoped=true"
import script from "./MovieSearch.vue?vue&type=script&lang=js"
export * from "./MovieSearch.vue?vue&type=script&lang=js"

import "./MovieSearch.vue?vue&type=style&index=0&id=32f2e3ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f2e3ae"]])

export default __exports__